import styled from '@emotion/styled'
import Folder from '../../components/Folder'
import {PageTitle} from '../../../_metronic/layout/core'
import MultiSelect from '../../components/MultiSelect'
import DatePicker from 'react-datepicker'
import {useParams, useNavigate} from 'react-router-dom'
import {Check, Plus, Search, X} from 'lucide-react'

import 'react-datepicker/dist/react-datepicker.css'
import React, {FC, useEffect, useMemo, useRef, useState} from 'react'
import * as API from '../../api'

const AlertCreationWrapper = styled.div`
  position: relative;

  .form-item {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 15px;
  }

  .inline-item {
    position: relative;
    margin-bottom: 15px;
    display: flex;
    align-items: center;

    label,
    input {
      margin-right: 15px;
      margin-bottom: 0;
    }
  }

  .form-input {
    position: relative;
    width: 100%;
  }

  .react-datepicker__input-container input {
    border: 1px solid var(--kt-input-border-color);
    border-radius: 0.475rem;
  }

  .alert-option {
    position: relative;
    margin-right: 20px;
    margin-bottom: 10px;
  }

  .folder-content-wrapper {
    position: relative;
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
  }

  .folder-column {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 290px;
  }

  .right-button {
    position: absolute;
    right: 0;
  }

  select {
    option {
      text-wrap: wrap;
    }

    option:nth-child(even) {
      background-color: #f2f2f2;
    }
  }

  .selection-container {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-height: 100px;
    flex-wrap: wrap;

    .form-check {
      margin-bottom: 10px;
      margin-right: 30px;

      label {
        display: flex;
        align-items: center;
      }

      input {
        margin-right: 5px;
      }
    }
  }

  .monitor-alert-box {
    gap: 25px;
  }

  .alert-page-heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 28px;

    h2 {
      color: #172b4d;
      font-size: 1.6rem;
      font-weight: 700;
      margin: 4px 0 6px;
    }

    p {
      color: #6b7280;
      margin: 0;
      max-width: 720px;
    }
  }

  .alert-page-eyebrow {
    color: #0b63a4;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .campaign-picker {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    margin: 8px 0 28px;
    padding: 22px;
  }

  .campaign-picker__header {
    align-items: flex-start;
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 18px;

    h3 {
      color: #172b4d;
      font-size: 1.1rem;
      font-weight: 700;
      margin: 0 0 4px;
    }

    p {
      color: #64748b;
      margin: 0;
    }
  }

  .campaign-picker__badge {
    align-items: center;
    background: #e8f3fb;
    border-radius: 999px;
    color: #075985;
    display: inline-flex;
    font-size: 0.82rem;
    font-weight: 700;
    padding: 7px 12px;
    white-space: nowrap;
  }

  .campaign-search {
    display: grid;
    gap: 10px;
    grid-template-columns: minmax(0, 1fr) auto;
    position: relative;

    > svg {
      color: #64748b;
      left: 14px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    input {
      background: #fff;
      border-color: #cbd5e1;
      min-height: 46px;
      padding-left: 44px;
      padding-right: 16px;
    }
  }

  .campaign-search__button {
    align-items: center;
    display: inline-flex;
    gap: 8px;
    justify-content: center;
    min-height: 46px;
    min-width: 132px;
  }

  .campaign-search__hint {
    color: #64748b;
    font-size: 0.8rem;
    margin: 8px 0 0;
  }

  .campaign-grid {
    display: grid;
    gap: 18px;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    margin-top: 18px;
  }

  .campaign-panel {
    background: #fff;
    border: 1px solid #dbe3ec;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    min-height: 420px;
    overflow: hidden;
  }

  .campaign-panel__header {
    align-items: center;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    min-height: 58px;
    padding: 12px 16px;

    strong {
      color: #334155;
      font-size: 0.9rem;
    }

    span {
      color: #64748b;
      font-size: 0.78rem;
    }
  }

  .campaign-results {
    display: flex;
    flex: 1;
    flex-direction: column;
    max-height: 350px;
    min-height: 350px;
    overflow-y: auto;
    padding: 8px;
  }

  .campaign-row {
    align-items: center;
    background: transparent;
    border: 0;
    border-bottom: 1px solid #eef2f6;
    color: inherit;
    display: flex;
    gap: 12px;
    justify-content: space-between;
    min-height: 58px;
    padding: 10px;
    text-align: left;
    transition: background 120ms ease;
    width: 100%;

    &:hover:not(:disabled) {
      background: #f1f7fb;
    }

    &:last-child {
      border-bottom: 0;
    }

    &:disabled {
      cursor: default;
    }

    &.is-selected {
      background: #f0fdf4;
    }
  }

  .campaign-row__content {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
  }

  .campaign-row__id {
    color: #0b63a4;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    margin-bottom: 2px;
  }

  .campaign-row__name {
    color: #334155;
    font-size: 0.86rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .campaign-row__action {
    align-items: center;
    color: #0b63a4;
    display: inline-flex;
    flex: 0 0 auto;
    font-size: 0.76rem;
    font-weight: 700;
    gap: 5px;
  }

  .campaign-row__remove {
    align-items: center;
    background: #fff1f2;
    border: 0;
    border-radius: 8px;
    color: #be123c;
    display: inline-flex;
    flex: 0 0 auto;
    height: 32px;
    justify-content: center;
    transition: background 120ms ease;
    width: 32px;

    &:hover {
      background: #ffe4e6;
    }
  }

  .campaign-panel__footer {
    align-items: center;
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    min-height: 52px;
    padding: 8px 12px;
  }

  .campaign-empty-state {
    align-items: center;
    color: #64748b;
    display: flex;
    flex: 1;
    flex-direction: column;
    font-size: 0.86rem;
    justify-content: center;
    padding: 32px;
    text-align: center;

    strong {
      color: #334155;
      margin-bottom: 4px;
    }
  }

  .campaign-error {
    color: #b42318;
  }

  @media (max-width: 991px) {
    .campaign-search {
      grid-template-columns: 1fr;

      > svg {
        top: 23px;
      }
    }

    .campaign-search__button {
      width: 100%;
    }

    .campaign-grid {
      grid-template-columns: 1fr;
    }

    .campaign-picker__header,
    .alert-page-heading {
      flex-direction: column;
    }
  }
`

interface Props {
  data?: any
}

interface Campaign {
  IDRegraPromocao: string | number
  Nome_Promocao: string
}

const CAMPAIGN_RESULT_LIMIT = 50
const CAMPAIGN_MIN_SEARCH_LENGTH = 2

const AlertCreation: FC<Props> = (props: Props) => {
  const {alertId} = useParams()

  const [regions, setRegions] = useState<string[]>([])
  const [distributors, setDistributors] = useState<any[]>([])
  const [industries, setIndustries] = useState<any[]>([])
  const [selectedDistributors, setSelectedDistributors] = useState<any[]>([])
  const [selectedIndustries, setSelectedIndustries] = useState<any[]>([])
  const [selectedRegions, setSelectedRegions] = useState<string[]>([])

  const [notifications, setNotifications] = useState<any[]>([
    {label: 'Insight Experience', value: 'notification', force: true},
    {label: 'E-mail', value: 'email'},
  ])
  const [selectedNotifications, setSelectedNotifications] = useState<any[]>([])

  const [loading, setLoading] = useState(false)
  const [loadedData, setLoadedData] = useState<any>({})

  const [promos, setPromos] = useState<Campaign[]>([])
  const [savedPromos, setSavedPromos] = useState<Campaign[]>([])
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [searchedTerm, setSearchedTerm] = useState<string>('')
  const [hasMorePromos, setHasMorePromos] = useState(false)
  const [promosLoading, setPromosLoading] = useState(false)
  const [promosError, setPromosError] = useState('')
  const promosRequestId = useRef(0)
  const promosAbortController = useRef<AbortController | null>(null)

  const [name, setName] = useState<string>('')
  const [selectedAlert, setSelectedAlert] = useState<any>('promo')
  const [selloutActived, setSelloutActived] = useState<boolean>(false)
  const [verbaActived, setVerbaActived] = useState<boolean>(true)
  const [totalPedidosActived, setTotalPedidosActived] = useState<boolean>(false)
  const [totalLojasActived, setTotalLojasActived] = useState<boolean>(false)

  const [regiaoCentroNorte, setRegiaoCentroNorte] = useState<boolean>(alertId ? false : true)
  const [regiaoLeste, setRegiaoLeste] = useState<boolean>(alertId ? false : true)
  const [regiaoNordeste, setRegiaoNordeste] = useState<boolean>(alertId ? false : true)
  const [regiaoSaoPaulo, setRegiaoSaoPaulo] = useState<boolean>(alertId ? false : true)
  const [regiaoSul, setRegiaoSul] = useState<boolean>(alertId ? false : true)

  const [sellout, setSellout] = useState<number>(0)
  const [verba, setVerba] = useState<number>(0)
  const [pedidos, setPedidos] = useState<number>(0)
  const [lojas, setLojas] = useState<number>(0)

  const [startDate, setStartDate] = useState<Date | null>(new Date())
  const [endDate, setEndDate] = useState<Date>(
    new Date(new Date().setMonth(new Date().getMonth() + 1))
  )

  const REGIONS_ENABLED: boolean = false
  const DISTRIBUTORS_ENABLED: boolean = false

  const navigate = useNavigate()
  const selectedPromoIds = useMemo(
    () => new Set(savedPromos.map((promo) => String(promo.IDRegraPromocao))),
    [savedPromos]
  )

  const getIndustries = async () => {
    const response = await API.getIndustries()
    const data = response.data.map((item: any) => {
      return {
        value: item[0],
        label: item[1],
      }
    })
    const sorted = data.sort((a: any, b: any) => {
      if (a.label < b.label) {
        return -1
      }
      if (a.label > b.label) {
        return 1
      }
      return 0
    })
    setIndustries(sorted)
  }

  const handleCheck = (region: string, isChecked: boolean) => {
    if (isChecked) {
      setSelectedRegions([...selectedRegions, region])
    } else {
      setSelectedRegions(selectedRegions.filter((item) => item !== region))
    }
  }

  const handleNotificationCheck = (notification: any, isChecked: boolean) => {
    if (isChecked) {
      setSelectedNotifications([...selectedNotifications, notification.value])
    } else {
      setSelectedNotifications(selectedNotifications.filter((item) => item !== notification.value))
    }
  }

  const addPromoItem = (promo: Campaign) => {
    if (selectedPromoIds.has(String(promo.IDRegraPromocao))) return
    setSavedPromos((current) => [...current, promo])
  }

  const removePromoItem = (promoId: Campaign['IDRegraPromocao']) => {
    setSavedPromos((current) =>
      current.filter((promo) => String(promo.IDRegraPromocao) !== String(promoId))
    )
  }

  const handleCampaignSearch = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const normalizedSearch = searchTerm.trim()
    if (normalizedSearch.length < CAMPAIGN_MIN_SEARCH_LENGTH) {
      promosAbortController.current?.abort()
      promosRequestId.current += 1
      setSearchedTerm('')
      setPromos([])
      setHasMorePromos(false)
      setPromosLoading(false)
      setPromosError('')
      return
    }

    promosAbortController.current?.abort()
    const abortController = new AbortController()
    promosAbortController.current = abortController
    const requestId = ++promosRequestId.current
    setSearchedTerm(normalizedSearch)
    setPromos([])
    setHasMorePromos(false)
    setPromosLoading(true)
    setPromosError('')

    try {
      const response = await API.getMonitorPromos(
        normalizedSearch,
        CAMPAIGN_RESULT_LIMIT,
        abortController.signal
      )
      if (!response.success) throw new Error(response.error || 'GET_MONITOR_PROMOS_FAIL')

      const responseData = Array.isArray(response.data) ? response.data : []
      const data = responseData.slice(0, CAMPAIGN_RESULT_LIMIT).map((item: any) => ({
        IDRegraPromocao: item[0],
        Nome_Promocao: item[1] || 'Campanha sem nome',
      }))
      if (requestId !== promosRequestId.current) return

      setPromos(data)
      setHasMorePromos(Boolean(response.hasMore) || responseData.length > CAMPAIGN_RESULT_LIMIT)
    } catch (error) {
      if (abortController.signal.aborted || requestId !== promosRequestId.current) return
      setPromos([])
      setHasMorePromos(false)
      setPromosError('Não foi possível carregar as campanhas. Tente novamente.')
    } finally {
      if (requestId === promosRequestId.current) setPromosLoading(false)
      if (promosAbortController.current === abortController) {
        promosAbortController.current = null
      }
    }
  }

  useEffect(() => {
    return () => {
      promosAbortController.current?.abort()
      promosRequestId.current += 1
    }
  }, [])

  const getSelectedMetrics = () => {
    return [{type: 'verba', value: verba}, {sellout: 0}, {lojas: 0}, {pedidos: 0}]
    const data = []
    if (selloutActived) data.push({type: 'sellout', value: sellout})
    if (verbaActived) data.push({type: 'verba', value: verba})
    if (totalLojasActived) data.push({type: 'lojas', value: lojas})
    if (totalPedidosActived) data.push({type: 'pedidos', value: pedidos})
    return data
  }

  const getDistributorsData = () => {
    const data: any = []
    selectedDistributors.forEach((distributor: any) => {
      data.push({
        SKIndustria: distributor.SKIndustria,
        IDDistribuidor: distributor.IDDistribuidor,
      })
    })
    return data
  }

  const getIndustriesData = () => {
    const data: any = []
    selectedIndustries.forEach((industrie: any) => {
      data.push({
        id: industrie.value,
        label: industrie.label,
      })
    })
    return data
  }

  const getData = () => {
    return {
      promos: savedPromos,
      regions: selectedRegions,
      metrics: getSelectedMetrics(),
      distributors: getDistributorsData(),
      industries: getIndustriesData(),
      notifications: selectedNotifications,
      type: selectedAlert,
      start: startDate,
      end: endDate,
      name,
    }
  }

  const getSelectedAlert = async () => {
    if (!alertId) return
    try {
      const response = await API.getAlert(alertId)
      const data = JSON.parse(response.data.data)
      setLoadedData(data)
      setName(data.name)
      setStartDate(new Date(data.start))
      setEndDate(new Date(data.end))
      setSelectedAlert(data.type)
      if (data.industries) {
        setSelectedIndustries(
          data.industries.map((industry: any) => {
            return {
              value: industry.id,
              label: industry.label,
            }
          })
        )
      }
      setSavedPromos(data.promos || [])
      ;(data.metrics || []).forEach((metric: any) => {
        if (metric.type == 'sellout') {
          setSelloutActived(true)
          setSellout(metric.value)
        }
        if (metric.type == 'verba') {
          setVerbaActived(true)
          setVerba(metric.value)
        }
        if (metric.type == 'pedidos') {
          setTotalPedidosActived(true)
          setPedidos(metric.value)
        }
        if (metric.type == 'lojas') {
          setTotalLojasActived(true)
          setLojas(metric.value)
        }
      })
      setSelectedNotifications(data.notifications || [])
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    if (!loadedData || !loadedData.regions) return
    setSelectedRegions(loadedData.regions)
  }, [loadedData.regions])

  useEffect(() => {
    if (!loadedData || !loadedData.distributors) return
    const data: any = []
    distributors.forEach((distributor) => {
      const result = loadedData.distributors.find(
        (i: any) =>
          i.IDDistribuidor == distributor.IDDistribuidor && i.SKIndustria == distributor.SKIndustria
      )
      if (result) data.push(distributor)
    })
    setSelectedDistributors(data)
  }, [loadedData.distributors])

  const generateAlert = async () => {
    const data = getData()
    setLoading(true)
    try {
      if (alertId) {
        trackEvent('Editar alerta')
        await API.editAlert(alertId, data)
      } else {
        trackEvent('Criar alerta')
        await API.addNewMonitorAlert(data)
      }
      setLoading(false)
      navigate('/alerts/list')
    } catch (e) {
      setLoading(false)
    }
  }

  const getRegions = async () => {
    const response = await API.getAlertRegions()
    const regions: any = []
    response.data.forEach((item: any) => {
      if (item.Regiao) regions.push(item.Regiao)
    })
    setRegions(regions)
  }

  const getDistributors = async () => {
    const response = await API.getAlertDistributors()
    const data: any = []
    response.data.forEach((item: any) => {
      item.value = `${item.SKIndustria}_${item.IDDistribuidor}`
      item.label = `${item.NomeIndustria} - ${item.NomeCurtoDistribuidor}`
      data.push(item)
    })
    setDistributors(data)
  }

  const checkDisabledButton = () => {
    const data = getData()
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    if (!data.name || !data.name.length) return true
    if (!data.metrics.length) return true
    if (!data.promos.length) return true
    if (!data.industries.length) return true
    // if (!data.notifications.length) return true;
    if (DISTRIBUTORS_ENABLED && !data.distributors.length) return true
    if (REGIONS_ENABLED && !data.regions.length) return true

    const endDateTemp = new Date(endDate.getTime())
    endDateTemp.setHours(0, 0, 0, 0)
    if (endDateTemp.getTime() < today.getTime()) return true
    return false
  }

  useEffect(() => {
    getIndustries()
    getSelectedAlert()
  }, [])

  const trackEvent = (title: string): any => {
    window.gtag('event', 'click', {
      event_category: 'Criação de alerta',
      event_label: `${title}`,
    })
  }

  return (
    <AlertCreationWrapper>
      <PageTitle>{alertId ? 'Editar alerta' : 'Criar alerta'}</PageTitle>
      <div className='card card-custom gutter-b p-10'>
        <div className='alert-page-heading'>
          <div>
            <span className='alert-page-eyebrow'>Monitor de alertas</span>
            <h2>{alertId ? 'Editar configuração do alerta' : 'Criar um novo alerta'}</h2>
            <p>
              Escolha as campanhas, defina a indústria e informe o valor que deve disparar a
              notificação.
            </p>
          </div>
        </div>

        <div className='form-item'>
          <label htmlFor='alert-name' className='form-label'>
            Nome do alerta
          </label>
          <input
            id='alert-name'
            type='text'
            value={name}
            placeholder='Ex.: Campanhas de verão — verba consumida'
            onChange={(e) => setName(e.target.value)}
            className='form-input form-control'
          />
        </div>

        <section className='campaign-picker' aria-labelledby='campaign-picker-title'>
          <div className='campaign-picker__header'>
            <div>
              <h3 id='campaign-picker-title'>Campanhas monitoradas</h3>
              <p>Busque por código ou nome e adicione somente as campanhas deste alerta.</p>
            </div>
            <span className='campaign-picker__badge'>
              {savedPromos.length} {savedPromos.length === 1 ? 'selecionada' : 'selecionadas'}
            </span>
          </div>

          <label htmlFor='campaign-search' className='form-label'>
            Buscar campanhas
          </label>
          <form className='campaign-search' onSubmit={handleCampaignSearch}>
            <Search size={18} aria-hidden='true' />
            <input
              id='campaign-search'
              className='form-input form-control'
              type='search'
              value={searchTerm}
              placeholder='Digite o código ou nome da campanha'
              autoComplete='off'
              aria-describedby='campaign-search-hint'
              onChange={(event) => setSearchTerm(event.target.value)}
            />
            <button
              type='submit'
              className='btn btn-primary campaign-search__button'
              disabled={promosLoading || searchTerm.trim().length < CAMPAIGN_MIN_SEARCH_LENGTH}
            >
              <Search size={16} aria-hidden='true' />
              {promosLoading ? 'Pesquisando...' : 'Pesquisar'}
            </button>
          </form>
          <p id='campaign-search-hint' className='campaign-search__hint'>
            Digite pelo menos 2 caracteres e clique em Pesquisar ou pressione Enter. Exibimos até{' '}
            {CAMPAIGN_RESULT_LIMIT} resultados.
          </p>

          <div className='campaign-grid'>
            <div className='campaign-panel'>
              <div className='campaign-panel__header'>
                <strong>Campanhas disponíveis</strong>
                <span>
                  {promosLoading
                    ? 'Atualizando...'
                    : !searchedTerm
                    ? 'Aguardando pesquisa'
                    : `${promos.length}${hasMorePromos ? '+' : ''} resultados`}
                </span>
              </div>
              <div className='campaign-results' aria-busy={promosLoading}>
                {!searchedTerm ? (
                  <div className='campaign-empty-state'>
                    <strong>Encontre a campanha que deseja monitorar</strong>
                    <span>Digite o código ou nome e clique em Pesquisar.</span>
                  </div>
                ) : promosError ? (
                  <div className='campaign-empty-state campaign-error'>{promosError}</div>
                ) : !promos.length && promosLoading ? (
                  <div className='campaign-empty-state'>Carregando campanhas...</div>
                ) : !promos.length ? (
                  <div className='campaign-empty-state'>
                    <strong>Nenhuma campanha encontrada</strong>
                    <span>Tente buscar por outro código ou nome.</span>
                  </div>
                ) : (
                  promos.map((promo) => {
                    const isSelected = selectedPromoIds.has(String(promo.IDRegraPromocao))
                    return (
                      <button
                        type='button'
                        key={`available_${promo.IDRegraPromocao}_${promo.Nome_Promocao}`}
                        className={`campaign-row ${isSelected ? 'is-selected' : ''}`}
                        disabled={isSelected || promosLoading}
                        aria-pressed={isSelected}
                        onClick={() => addPromoItem(promo)}
                      >
                        <span className='campaign-row__content'>
                          <span className='campaign-row__id'>#{promo.IDRegraPromocao}</span>
                          <span className='campaign-row__name' title={promo.Nome_Promocao}>
                            {promo.Nome_Promocao}
                          </span>
                        </span>
                        <span className='campaign-row__action'>
                          {isSelected ? <Check size={15} /> : <Plus size={15} />}
                          {isSelected ? 'Adicionada' : 'Adicionar'}
                        </span>
                      </button>
                    )
                  })
                )}
              </div>
              <div className='campaign-panel__footer'>
                <span>
                  {hasMorePromos
                    ? `Mostrando os primeiros ${CAMPAIGN_RESULT_LIMIT}. Refine a busca para encontrar outros.`
                    : searchedTerm
                    ? `${promos.length} ${
                        promos.length === 1 ? 'resultado exibido' : 'resultados exibidos'
                      } para “${searchedTerm}”`
                    : 'A lista completa não é carregada.'}
                </span>
              </div>
            </div>

            <div className='campaign-panel'>
              <div className='campaign-panel__header'>
                <strong>Selecionadas para o alerta</strong>
                <span>{savedPromos.length} no alerta</span>
              </div>
              <div className='campaign-results'>
                {!savedPromos.length ? (
                  <div className='campaign-empty-state'>
                    <strong>Nenhuma campanha selecionada</strong>
                    <span>Use “Adicionar” na lista ao lado para montar o alerta.</span>
                  </div>
                ) : (
                  savedPromos.map((promo) => (
                    <div
                      className='campaign-row'
                      key={`selected_${promo.IDRegraPromocao}_${promo.Nome_Promocao}`}
                    >
                      <span className='campaign-row__content'>
                        <span className='campaign-row__id'>#{promo.IDRegraPromocao}</span>
                        <span className='campaign-row__name' title={promo.Nome_Promocao}>
                          {promo.Nome_Promocao}
                        </span>
                      </span>
                      <button
                        type='button'
                        className='campaign-row__remove'
                        title='Remover campanha'
                        aria-label={`Remover campanha ${promo.Nome_Promocao}`}
                        onClick={() => removePromoItem(promo.IDRegraPromocao)}
                      >
                        <X size={16} />
                      </button>
                    </div>
                  ))
                )}
              </div>
              <div className='campaign-panel__footer'>
                <span>As campanhas selecionadas serão salvas neste alerta.</span>
              </div>
            </div>
          </div>
        </section>
        {/* <div className="d-flex inline-item">
                    <label>Listar campanha por:</label> <label htmlFor="optDescription" className="form-label">Descrição</label><input name="optListBy" type="radio" id="optDescription" className="campaign-type form-check-input" /><label htmlFor="optMechanic" className="form-label">Mecânica</label><input name="optListBy" type="radio" id="optMechanic" className="campaign-type form-check-input" />
                </div> */}
        <div className='d-flex monitor-alert-box'>
          {/* <Folder isOpen={true} toggleEnabled={false} title="Tipo de alerta">
                        <div className="selection-container">
                            <div className="form-check form-check-custom form-check-solid">
                                <label className=""><input type="radio" name="alert-type" value='promo' checked={ selectedAlert === 'promo' } onChange={() => { setSelectedAlert('promo') }} className="form-check-input" />Promoções</label>
                            </div>
                            <div className="form-check form-check-custom form-check-solid">
                                <label className=""><input type="radio" name="alert-type" value='price' checked={ selectedAlert === 'price' } onChange={() => { setSelectedAlert('price') }} className="form-check-input" />Preço</label>
                            </div>
                        </div>
                    </Folder> */}
          <Folder isOpen={true} toggleEnabled={false} title='Métricas'>
            <div className='selection-container'>
              <div className='form-check form-check-custom form-check-solid'>
                <label>
                  <input
                    type='checkbox'
                    checked={verbaActived}
                    disabled
                    onChange={(e) => {
                      setVerbaActived(e.target.checked)
                    }}
                    className='form-check-input'
                  />
                  Verba consumida
                </label>
              </div>
              {/* 
                            <div className="form-check form-check-custom form-check-solid"><label><input type="checkbox" checked={selloutActived} onChange={(e) => {
                                setSelloutActived(e.target.checked);
                            }} className="form-check-input" />Sellout captado</label></div>
                            
                            <div className="form-check form-check-custom form-check-solid"><label><input type="checkbox" checked={totalPedidosActived}  onChange={(e) => {
                                setTotalPedidosActived(e.target.checked);
                            }} className="form-check-input" />Total de pedidos</label></div>
                            <div className="form-check form-check-custom form-check-solid"><label><input type="checkbox" checked={totalLojasActived}  onChange={(e) => {
                                setTotalLojasActived(e.target.checked);
                            }} className="form-check-input" />Total de lojas</label></div>
                        */}
            </div>
          </Folder>
          {REGIONS_ENABLED ? (
            <Folder isOpen={true} toggleEnabled={false} title='Regiões'>
              <div className='selection-container'>
                {regions.map((regiao) => (
                  <div className='form-check form-check-custom form-check-solid' key={regiao}>
                    <label>
                      <input
                        type='checkbox'
                        className='form-check-input'
                        checked={selectedRegions.includes(regiao)}
                        onChange={(e: any) => handleCheck(regiao, e.target.checked)}
                      />
                      {regiao}
                    </label>
                  </div>
                ))}
              </div>
            </Folder>
          ) : null}
          {DISTRIBUTORS_ENABLED ? (
            <Folder isOpen={true} toggleEnabled={false} title='Distribuidores'>
              <div className='selection-container'>
                <MultiSelect
                  options={distributors}
                  isSelectAll={true}
                  isMulti
                  closeMenuOnSelect={false}
                  menuPlacement={'bottom'}
                  value={selectedDistributors}
                  onChange={(selected: []) => {
                    setSelectedDistributors(selected || [])
                  }}
                />
              </div>
            </Folder>
          ) : null}
          <Folder isOpen={true} toggleEnabled={false} title='Notificações'>
            <div className='selection-container'>
              {notifications.map((notification) => (
                <div
                  className='form-check form-check-custom form-check-solid'
                  key={notification.value}
                >
                  <label>
                    <input
                      type='checkbox'
                      className='form-check-input'
                      disabled={notification.force}
                      checked={
                        selectedNotifications.includes(notification.value) || notification.force
                      }
                      onChange={(e: any) => handleNotificationCheck(notification, e.target.checked)}
                    />
                    {notification.label}
                  </label>
                </div>
              ))}
            </div>
          </Folder>
          <Folder isOpen={true} toggleEnabled={false} title='Indústrias'>
            <div className='folder-content-wrapper'>
              <div className='folder-column'>
                <div className='form-item'>
                  <MultiSelect
                    options={industries}
                    value={selectedIndustries}
                    isSelectAll={true}
                    menuPlacement={'bottom'}
                    onChange={(selected: []) => setSelectedIndustries(selected || [])}
                  />
                </div>
              </div>
            </div>
          </Folder>
        </div>
        {selloutActived || verbaActived || totalPedidosActived || totalLojasActived ? (
          <Folder isOpen={true} toggleEnabled={false} title='Alertar ao atingir determinado valor'>
            <div className='monitor-alert-box'>
              {/*{ selloutActived ?
                        <div className="folder-column mb-4">
                        <label htmlFor="" className="form-label">Sellout captado R$</label>
                        <div className="d-flex">
                            <span className="input-group-text">R$</span>
                            <input type="number" defaultValue={sellout} onChange={(e:any) => setSellout(e.target.value)} className="form-input form-control"/>
                        </div>
                    </div> : null } */}
              {verbaActived ? (
                <div className='folder-column mb-4'>
                  <label htmlFor='' className='form-label'>
                    Verba captada R$
                  </label>
                  <div className='d-flex'>
                    <span className='input-group-text'>R$</span>
                    <input
                      type='number'
                      value={verba}
                      onChange={(e: any) => setVerba(e.target.value)}
                      className='form-input form-control'
                    />
                  </div>
                </div>
              ) : null}
              {/*
                        { totalLojasActived ?
                        <div className="folder-column mb-4">
                            <label htmlFor="" className="form-label">Total de lojas</label>
                            <input type="number" defaultValue={lojas} onChange={(e:any) => setLojas(e.target.value)} className="form-input form-control" />
                        </div> : null }
                        { totalPedidosActived ?
                        <div className="folder-column mb-4">
                            <label htmlFor="" className="form-label">Total de pedidos</label>
                            <input type="number" defaultValue={pedidos} onChange={(e:any) => setPedidos(e.target.value)}  className="form-input form-control" />
                        </div> : null }
                        */}
              <div className='d-flex'>
                <div className='folder-column w-50 m-2'>
                  <label htmlFor='' className='form-label'>
                    Monitorar a partir da data
                  </label>
                  <DatePicker
                    dateFormat={'dd/MM/yyyy'}
                    selected={startDate}
                    onChange={(date: any) => {
                      setStartDate(date)
                    }}
                    className='form-input form-control'
                  />
                </div>
                <div className='folder-column w-50 m-2'>
                  <label htmlFor='' className='form-label'>
                    Monitorar até a data
                  </label>
                  <DatePicker
                    dateFormat={'dd/MM/yyyy'}
                    selected={endDate}
                    onChange={(date: any) => {
                      setEndDate(date)
                    }}
                    className='form-input form-control'
                  />
                </div>
              </div>
              {/*
                        <div className="folder-column">
                            <label htmlFor="" className="form-label">Data início</label>
                            <DatePicker dateFormat={'dd/MM/yyyy'} selected={startDate} onChange={(date) => { setStartDate(date) }} className="form-input form-control" />
                        </div>
                        <div className="folder-column">
                            <label htmlFor="" className="form-label">Data fim</label>
                            <DatePicker dateFormat={'dd/MM/yyyy'} selected={endDate} onChange={(date) => { setEndDate(date) }} className="form-input form-control" />
                        </div>
                        */}
            </div>
          </Folder>
        ) : null}

        {/* 
                <Folder isOpen={true} toggleEnabled={false} title="Método de envio">
                    <div className="folder-content-wrapper">
                        <div className="folder-column">
                            <div className="form-item">
                                <label htmlFor="" className="form-label">Modo de envio</label>
                                <MultiSelect
                                    options={[
                                        { value: 'notification', label: 'Notificação' },
                                        { value: 'email', label: 'E-mail' },
                                        { value: 'whatsapp', label: 'WhatsApp' },
                                        { value: 'sms', label: 'SMS' }
                                    ]}
                                    isSelectAll={true}
                                    menuPlacement={"bottom"}
                                    onChange={ (selected:[]) => setSelectedSendMethods(selected || []) }
                                />
                            </div>
                            <div className="form-item">
                                <label htmlFor="" className="form-label">Usuários</label>
                                <MultiSelect
                                    options={[
                                        { value: 0, label: 'Antônio Albuquerque' },
                                        { value: 1, label: 'Bernardo Cunha' },
                                        { value: 2, label: 'Carla Antunes' }
                                    ]}
                                    isSelectAll={true}
                                    menuPlacement={"bottom"}
                                    onChange={ (selected:[]) => setSelectedUsers(selected || []) }
                                />
                            </div>
                        </div>
                        <div className="folder-column">
                            <div className="form-item">
                                <label htmlFor="" className="form-label">Nome do alerta</label><input type="text" className="form-input form-control" />
                            </div>
                        </div>
                    </div>
                </Folder>
                */}

        <div className='form-item'>
          <div className='text-center'>
            <button
              type='submit'
              id='kt_sign_in_submit'
              className='btn btn-lg btn-primary w-50 mt-5'
              disabled={checkDisabledButton()}
              onClick={() => {
                generateAlert()
              }}
            >
              {!loading && (
                <span className='indicator-label'>
                  {alertId ? 'Editar alerta' : 'Gerar novo alerta'}
                </span>
              )}
              {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Aguarde por favor...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </div>
        {/* <div className="form-check form-check-custom form-check-solid">
                        <label><input type="checkbox" className="form-check-input" />* Aceitar termos e condições</label>
                    </div> */}
      </div>
    </AlertCreationWrapper>
  )
}

export default AlertCreation
